import React from 'react';
import { DealerGroup } from '../../types/Group';

interface GroupTableProps {
  groups: DealerGroup[];
  loading: boolean;
  onEdit: (group: DealerGroup) => void;
  onDelete: (id: number) => void;
}

const GroupTable: React.FC<GroupTableProps> = ({ groups, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading dealer groups...</p>
      </div>
    );
  }

  if (groups.length === 0) {
    return (
      <div className="empty-state">
        <p>No dealer groups found. Click "Add New Group" to create one.</p>
      </div>
    );
  }

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Dealer Code</th>
            <th>Group Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((group) => (
            <tr key={group.id}>
              <td>{group.id}</td>
              <td>{group.dealerCode}</td>
              <td>{group.groupName}</td>
              <td className="table-actions">
                <button 
                  className="edit-button action-button"
                  onClick={() => onEdit(group)}
                >
                  Edit
                </button>
                <button 
                  className="delete-button action-button"
                  onClick={() => group.id && onDelete(group.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GroupTable; 